export const EXPERIMENTAL_FEATURES_STORAGE_KEY = 'band-space-experimental-features';

/** Mirrors ExperimentalFeaturesProvider: explicit localStorage, else on in development. */
export function isExperimentalFeaturesEnabled(): boolean {
  const stored = localStorage.getItem(EXPERIMENTAL_FEATURES_STORAGE_KEY);
  if (stored === 'true') return true;
  if (stored === 'false') return false;
  return process.env.NODE_ENV === 'development';
}

/** When UI experimental mode is on, ask the API to include test organizations. */
export function applyAllowTestOrgsHeader(headers: {
  [key: string]: unknown;
  set?: (name: string, value: string) => void;
}): void {
  if (!isExperimentalFeaturesEnabled()) return;
  if (typeof headers.set === 'function') {
    headers.set('X-Allow-Test-Orgs', 'true');
  } else {
    headers['X-Allow-Test-Orgs'] = 'true';
  }
}
